/* Vintedoisk (25/10/2026) — calculadora de frete da sacola/carrinho só com o CEP.
   A Shopify exige o estado para calcular; ele sai do CEP (faixas dos Correios) e vai para o select escondido
   (snippets/cart-shipping-calculator.liquid). Fica num arquivo global porque a sacola lateral é redesenhada por JS
   e script dentro dela não executa. Também traz o CEP já digitado na calculadora da página de produto (vk_cep). */
(function () {
  var FAIXAS = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],[72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
  var CAMPO = '.shipping-calculator-form input[name="address[zip]"]';

  function ufDoCep(cep) {
    var n = +cep.slice(0, 5);
    for (var i = 0; i < FAIXAS.length; i++) if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    return '';
  }
  function aplicar(campo) {
    var dig = campo.value.replace(/\D/g, '');
    var sel = campo.form && campo.form.querySelector('select[name="address[province]"]');
    if (sel) sel.value = dig.length === 8 ? ufDoCep(dig) : '';
    if (dig.length === 8) { try { localStorage.setItem('vk_cep', dig); } catch (e) {} }
  }
  window.vkUfDoCep = aplicar; // usado pelo oninput do campo

  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches(CAMPO)) aplicar(e.target); });
  document.addEventListener('focusin', function (e) {
    var c = e.target;
    if (!c.matches || !c.matches(CAMPO) || c.value) return;
    try { var s = localStorage.getItem('vk_cep'); if (s && s.length === 8) { c.value = s.slice(0, 5) + '-' + s.slice(5); aplicar(c); } } catch (err) {}
  });
  // o tema escreve o resultado como "BRL 19.90" / "BRL 0.00" → "R$ 19,90" / "Grátis"
  function formatar(el) {
    var feito = false;
    el.querySelectorAll('*').forEach(function (n) {
      if (n.children.length) return;
      var t = n.textContent, novo = t.replace(/BRL\s?(\d+)[.,](\d{2})/g, function (_, r, c) { return (+r === 0 && c === '00') ? 'Grátis' : 'R$ ' + r + ',' + c; });
      if (novo !== t) { n.textContent = novo; feito = true; }
    });
    return feito;
  }
  new MutationObserver(function (mut) {
    mut.forEach(function (m) { var r = m.target.closest && m.target.closest('.results'); if (r) formatar(r); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // garantia: no envio, o estado é preenchido antes de a calculadora do tema ler o formulário
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('.shipping-calculator-form')) { var c = f.querySelector('input[name="address[zip]"]'); if (c) aplicar(c); }
  }, true);
})();
